import React, { useEffect, useMemo } from 'react'

import { Link } from 'react-router-dom'
import { UIAlert, UIButton, UIText } from 'components'
import { useGlobalContext } from 'contexts/global'
import { ErrorPage } from 'pages/ErrorPage'
import { sendSelectContent } from 'utils'
import { mainContent } from 'constants/content'

import { interWbNavigate } from '@interco/inter-webview-bridge'
import IcImage from '@interco/icons/core/media-communication/ic_image'

import { SkeletoIntro } from './skeleton'
import * as S from './styles'
import { useIntro } from './hooks/useIntro'

export const Intro = () => {
  const { client, isError, errorData, isLoading, consentRequested } = useIntro()

  const { setHeaderPage, content } = useGlobalContext()

  const selectedMainContent = useMemo(() => {
    const mainContentkey = client.name as keyof typeof mainContent

    const hasCustomContent = Object.keys(mainContent).includes(mainContentkey)

    if (hasCustomContent) return mainContent[mainContentkey]

    return mainContent.others
  }, [client, content])

  useEffect(() => {
    setHeaderPage({
      title: content.firstStep.header,
      hideLeftButton: true,
      showRightButton: true,
    })
  }, [setHeaderPage, content])

  if (isError) {
    return (
      <ErrorPage
        onContinue={() => interWbNavigate.requestGoBack()}
        errorData={errorData}
        client={client?.name}
      />
    )
  }

  if (isLoading)
    return (
      <S.DivIntro>
        <SkeletoIntro />
      </S.DivIntro>
    )

  return (
    <S.DivIntro>
      <S.IntroImage>
        {client?.logo ? (
          <S.LogoImage src={client.logo} />
        ) : (
          <IcImage height={50} width={50} color="var(--gray400)" />
        )}
      </S.IntroImage>

      <UIText variant="headline-h1" semiBold>
        {content.firstStep.headline.replaceAll(':clientName', client.name || '[cliente]')}
      </UIText>

      <UIText variant="body-3">
        {selectedMainContent.replaceAll(':clientName', client.name || '[cliente]').replaceAll(
          ':infoList',
          consentRequested.userinfo?.reduce((prev, curr, index) => {
            const isLastInfo = consentRequested.userinfo.length - 1 === index
            const separator = consentRequested.userinfo.length - 2 === index ? ' e ' : ', '

            return prev.concat(curr.description).concat(isLastInfo ? '' : separator)
          }, '') ?? '',
        )}
      </UIText>

      <S.ContentContainer>
        <UIAlert
          title={content.firstStep.alertTitle.replaceAll(':clientName', client.name || '[cliente]')}
          type="warning"
        >
          {content.firstStep.alertContent.replaceAll(':clientName', client.name || '[cliente]')}
        </UIAlert>

        <S.ButtonContainer>
          <Link
            to="/consent"
            onClick={() => {
              if (client) {
                sendSelectContent({
                  scenario: client.name,
                  step: 'authentication',
                  element_name: 'Próximo',
                  element_type: 'button',
                  parent_name: 'intro',
                })
              }
            }}
          >
            <UIButton variant="primary" fullWidth isLoading={isLoading}>
              {content.firstStep.buttonLabel.replaceAll(':clientName', client.name || '[cliente]')}
            </UIButton>
          </Link>
        </S.ButtonContainer>
      </S.ContentContainer>
    </S.DivIntro>
  )
}
